export function initializeSalaryFilters(translate) {
  let initialFilters = [
    {
      id: "nogaCode",
      label: translate("benchmarking.evaluations.salary.filters.noga"),
      items: [],
    },
    {
      id: "greaterRegion",
      label: translate("benchmarking.evaluations.salary.filters.canton"),
      items: [],
    },
    {
      id: "sex",
      label: translate("benchmarking.evaluations.salary.filters.gender"),
      items: [],
    },
    {
      id: "surveyYears",
      label: translate("benchmarking.evaluations.salary.filters.year"),
      items: [],
    },
    {
      id: "officeSize",
      label: translate("benchmarking.evaluations.salary.filters.officeSize"),
      items: [],
      ignoreSort: true,
    },
    {
      id: "ageCategory",
      label: translate("benchmarking.evaluations.salary.filters.ageGroup"),
      items: [],
    },
    {
      id: "levelId",
      label: translate("benchmarking.evaluations.salary.filters.typeOfEmployment"),
      items: [],
    },
    {
      id: "functionId",
      label: translate("benchmarking.evaluations.salary.filters.function"),
      items: [],
    },
  ];
  return { filters: initialFilters, newest: true, isInitialLoad: true, allAvailabeFilters: {} };
}
